import React, { useState } from 'react';
import {Button} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { useDropzone } from 'react-dropzone';
import CloudUploadIcon from '@material-ui/icons/CloudUpload'; // Importer l'icône CloudUpload
import {  toast } from 'react-toastify';

const ImportProduct = (props) => {
  const [ouvert, setOuvert] = useState(true);
  const [option, setOption] = useState('option1');
  const [id, setId] = useState('');
  const [fichierJson, setFichierJson] = useState(null);
  const [jsonData, setJsonData] = useState(null); // État pour stocker les données JSON analysées

  const handleClose = () => {
    setOuvert(false);
  };
  const handleOptionChange = (value) => {
    setOption(value);
  };

  const handleIdChange = (event) => {
    setId(event.target.value);
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'application/json',
    onDrop: (acceptedFiles) => {
      setFichierJson(acceptedFiles[0]);
      const reader = new FileReader();
      reader.onload = () => {
        try {
          const jsonData = JSON.parse(reader.result);
          setJsonData(jsonData);
        } catch (error) {
          toast.error('Erreur lors de l\'analyse du fichier JSON :'+ error);
        }
      };
      reader.readAsText(acceptedFiles[0]);
    },
  });
  const handleImport = async () => {
    console.log("handleImport",id)
    if (option === "option1"){
        try{
            const resp = await props.DuplicateProductFromID({"product_id":id})

            toast.error('Produit dupliqué avec succes')
            props.handleClose()
        }catch(err){
            toast.error("[ERROR]"+err.message)
        }
    }else{
        toast.error("Fonction pas disponible sur votre compte")
    }
  }

  return (
    <Dialog open={ouvert} onClose={props.handleClose} fullWidth={true} maxWidth="md">
        <DialogTitle>Importation</DialogTitle>
        <DialogContent style={{ width: '70vw' }}>
          <Typography>Choisir une option d'importation :</Typography>
          <br />
          <Button
            variant="contained"
            onClick={() => handleOptionChange('option1')} // Passer la valeur directement à la fonction
            color={option === 'option1' ? 'primary' : 'default'}
            style={{ marginRight: '10px' }}
          >
            Importation par ID
          </Button>
          <br />
          <br />
          <Button
            variant="contained"
            onClick={() => handleOptionChange('option2')} // Passer la valeur directement à la fonction
            color={option === 'option2' ? 'primary' : 'default'}
            style={{ marginRight: '10px' }}
          >
            Importation par JSON
          </Button>
          <br />
          <br />
          {option === 'option1' && 
            <TextField
              type="text"
              label="ID ex : CAB_NA_6DA25AL"
              value={id}
              onChange={handleIdChange}
            />
          }
          {option === 'option2' && 
          <div {...getRootProps()} style={{ border: '2px dashed #ccc', borderRadius: '5px', padding: '20px', textAlign: 'center', cursor: 'pointer' }}>
            <input {...getInputProps()} />
            <CloudUploadIcon style={{ fontSize: 48, color: '#ccc' }} />
            <Typography>
              Déposer un fichier JSON ici ou cliquer pour sélectionner un fichier
            </Typography>
            {fichierJson && (
              <Typography>Fichier sélectionné : {fichierJson.name}</Typography>
            )}
            {jsonData && (
              <pre>{JSON.stringify(jsonData, null, 2)}</pre>
            )}
          </div>
        }
        </DialogContent>
        <DialogActions>
          <Button onClick={props.handleClose} color="primary">
            Annuler
          </Button>
          <Button onClick={handleImport} color="primary">
            Importer
          </Button>
        </DialogActions>
      </Dialog>
  );
}

export default ImportProduct